import React from 'react';
import { CTAButton } from './CTAButton';
import { IMAGES } from '../data/landing';
export function Hero() {
  return <section className="bg-cream" aria-labelledby="hero-title" data-id="element-66" data-mp="eiv5ox3vlaku">
      <div className="mx-auto max-w-[1080px] px-5 pb-8 pt-4 md:pb-12 md:pt-8" data-id="element-67" data-mp="9kjxeqt8b84q">
        <div className="mx-auto flex max-w-[620px] flex-col items-center text-center" data-id="element-68" data-mp="9igxnf29y0mt">
          <span className="inline-block rounded-full border border-line bg-cream-soft px-2.5 py-[3px] text-[9px] uppercase tracking-[0.14em] text-ink-muted md:text-[10px]" style={{
          height: "26px"
        }} data-id="element-69" data-mp="4jm4bj6oktog">
            <span className="font-display font-semibold text-ink" data-id="element-70" data-mp="x8b85pz4fd3w">NEROVIX</span>
            <span className="mx-1.5" data-id="element-71" data-mp="s9q6dm480ldc">·</span>
            <span className="font-bold" data-id="element-72" data-mp="nc85mj0cxcgf">Mega Pack Hombre Magnético</span>
          </span>

          <h1 id="hero-title" className="mt-3 text-[26px] leading-[1.1] sm:text-[36px] lg:text-[44px]" style={{
          fontSize: "28px"
        }} data-id="element-73" data-mp="3d1ildbzsjgoh">
            Perfecciona el arte de la seducción {' '}
            <span className="text-gold" data-id="element-74" data-mp="384jq2q4e53op">en 7 días</span>
          </h1>

          <p className="mt-2.5 max-w-[390px] text-[12.5px] font-medium leading-snug text-ink-muted md:text-[14px] md:leading-relaxed" style={{
          fontSize: "14px",
          height: "80px"
        }} data-id="element-75" data-mp="3j925dog4jqvj">
            Entiende por qué una conexión se queda en amistad y mejora tu seguridad, intención y forma de comunicar interés,
sin parecer necesitado.
          </p>

          <div className="mt-3 w-full max-w-[300px]" data-id="element-76" data-mp="30i19586e29fo">
            <div className="overflow-hidden rounded-[12px] border border-line bg-cream-soft shadow-[0_14px_32px_-22px_rgba(18,17,15,0.5)]" data-id="element-77" data-mp="30gge7hg5woha">
              <img src={IMAGES.heroMockup} alt="Mega Pack Hombre Magnético — portada del sistema completo" width={700} height={700} className="block aspect-square h-auto w-full" fetchPriority="high" decoding="async" data-id="element-78" data-mp="2qjv96w457ddg" />
              
            </div>
          </div>

          <div className="mt-3 inline-flex items-center gap-2 rounded-full border border-line bg-cream-soft px-3.5 py-1.5" data-id="element-79" data-mp="2hjyp77sp72oq">
            <span className="text-[12px] font-medium text-ink-muted line-through" style={{
            fontSize: "14px"
          }} data-id="element-80" data-mp="2lml98mj4njbd">
              US$49
            </span>
            <span className="text-[19px] font-extrabold tracking-[-0.02em] text-ink" style={{
            fontSize: "20px"
          }} data-id="element-81" data-mp="na9yck53l6it">
              US$19
            </span>
            <span className="rounded-full bg-cream-2 px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-[0.1em] text-ink-muted" style={{
            fontSize: "12px"
          }} data-id="element-82" data-mp="dd5dqoqwhj44">
              Pago único
            </span>
          </div>

          <div className="mt-3 w-full max-w-[330px]" data-id="element-83" data-mp="161b01fxlrg62">
            <CTAButton label="Quiero generar más atracción" data-id="element-84" data-mp="15zq1zgc2xf3g" />
          </div>

          
        </div>
      <p className="mt-2 text-[10px] font-medium tracking-[0.02em] text-ink-muted" style={{
        fontSize: "12px",
        textAlign: "center"
      }} data-id="element-85" data-mp="114swukhx7pvu">
            Acceso inmediato · Sin suscripción · Acceso de por vida
          </p></div>
    </section>;
}